import React from "react";
import Layout from "../components/Layout";
import { PageHero } from "../components/PageHero";
import { useLang } from "../contexts/LanguageContext";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import SectionedNarrative from "../components/SectionedNarrative";

const IMG = "/coaching-individuel.jpg";

export default function Coaching() {
  const { t } = useLang();
  const sections = t.coaching.sections || [];

  return (
    <Layout>
      <PageHero eyebrow={t.coaching.eyebrow} image={IMG} largeEyebrow />

      <SectionedNarrative sections={sections} testId="coaching" />

      <section className="py-20 px-6 md:px-10 max-w-[1400px] mx-auto">
        <div className="border border-black/10 p-10 md:p-16 flex flex-col md:flex-row items-start md:items-center justify-between gap-8 bg-white">
          <p className="font-serif text-3xl md:text-4xl font-light leading-tight max-w-2xl text-navy">{t.home.final_title}</p>
          <Link to="/contact" data-testid="coaching-cta" className="group inline-flex items-center gap-2 bg-brand hover:bg-brandDark text-white px-3 py-2 transition-colors flex-none">
            <span className="text-[10px] tracking-[0.22em] uppercase font-mono">{t.home.final_cta}</span>
            <ArrowUpRight size={12} className="transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" />
          </Link>
        </div>
      </section>
    </Layout>
  );
}
